import React, { useState } from 'react';
import '../../styles/pages.css';

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        <span>{question}</span>
        <span className="faq-icon">{isOpen ? '-' : '+'}</span>
      </button>
      {isOpen && (
        <div className="faq-answer">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

const FaqPage = () => {
  const faqs = {
    "SOBRE OS PRODUTOS": [
      {
        question: "Qual é o material das peças?",
        answer: "Trabalhamos com uma variedade de materiais de alta qualidade, incluindo Prata 925, Aço Inoxidável e semijoias banhadas a Ouro 18k. A descrição de cada produto especifica o material utilizado."
      },
      {
        question: "As peças têm garantia?",
        answer: "Sim! Oferecemos garantia permanente para a qualidade do metal (como Prata 925). Para o banho de ouro e eventuais defeitos de fabricação, a garantia é de 1 ano. A garantia não cobre danos por mau uso, como peças amassadas, arranhadas ou quebradas."
      },
      {
        question: "Como cuidar das minhas semijoias?",
        answer: "Para garantir a durabilidade de suas peças, evite o contato com produtos químicos, água do mar e piscina. Guarde-as individualmente em local seco e limpo. Limpe-as com uma flanela macia após o uso."
      }
    ],
    "PAGAMENTO": [
      {
        question: "Quais são as formas de pagamento?",
        answer: "Aceitamos os principais cartões de crédito (Visa, MasterCard, American Express), Pix e boleto bancário através do nosso gateway de pagamento seguro, o Mercado Pago."
      },
      {
        question: "Posso parcelar minha compra?",
        answer: "Sim, você pode parcelar suas compras no cartão de crédito em até 10x sem juros."
      },
      {
        question: "É seguro comprar neste site?",
        answer: "Sim! Nosso site possui certificado de segurança SSL, que criptografa todos os seus dados. Além disso, os pagamentos são processados por plataformas renomadas, garantindo total segurança para suas informações."
      }
    ],
    "ENVIO E ENTREGA": [
      {
        question: "Qual é o prazo de entrega?",
        answer: "O prazo de entrega varia de acordo com o seu CEP e a modalidade de envio escolhida. Você pode calcular o prazo e o valor exato na página do produto ou no carrinho de compras."
      },
      {
        question: "Como acompanho meu pedido?",
        answer: "Assim que seu pedido for enviado, você receberá um e-mail com o código de rastreamento. Você poderá usá-lo para acompanhar a entrega diretamente no site da transportadora."
      },
      {
        question: "Vocês entregam para todo o Brasil?",
        answer: "Sim, realizamos entregas em todo o território nacional."
      }
    ],
    "TROCAS E DEVOLUÇÕES": [
      {
        question: "Como faço para trocar ou devolver um produto?",
        answer: "Se você não estiver satisfeito com sua compra, pode solicitar a troca ou devolução em até 7 dias corridos após o recebimento do produto. A peça deve estar em perfeitas condições e na embalagem original. Entre em contato com nosso atendimento ao cliente para iniciar o processo."
      }
    ]
  };

  return (
    <div className="static-page faq-page">
      <h2 className="page-title">Perguntas Frequentes (FAQ)</h2>

      {Object.entries(faqs).map(([category, items]) => (
        <section key={category}>
          <h3>{category}</h3>
          {items.map((item, index) => (
            <FaqItem key={index} question={item.question} answer={item.answer} />
          ))}
        </section>
      ))}
    </div>
  );
};

export default FaqPage;
